class SearchService {
    /*@ngInject*/
    constructor($log, $http, $timeout, $rootScope) {
        this.$log = $log;
        this.$http = $http;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.focus = false;
        this.autocompleteUrl = '';
        this.minCharactersBeforeRequest = 0;
        this.waitTimeBeforeRequest = 0;
        this.delayTimer = null;
        this.searchTermLength = 0;
        this.resultsProducts = [];
        this.resultsSuggestions = [];
        this.productsText = null;
        this.suggestionsText = null;
        this.searchResultsPictureWidth = 0;
    }

    setProductsText(productsText) {
        this.productsText = productsText;
    }

    setSuggestionsText(suggestionsText) {
        this.suggestionsText = suggestionsText;
    }

    setSearchResultsPictureWidth(searchResultsPictureWidth) {
        this.searchResultsPictureWidth = searchResultsPictureWidth;
    }

    hasResults() {
        return !!this.resultsProducts.length || !!this.resultsSuggestions.length;
    }

    getFocus() {
        return this.focus;
    }

    addFocus() {
        this.focus = true;
    }

    removeFocus() {
        this.$timeout(() => {
            this.focus = false;
            // remove products on blur
            this.resultsProducts = [];
            this.resultsSuggestions = [];
        }, 500);
    }

    fetchSuggestions(term) {
        this.$log.debug('Get suggestions for ' + term);

        let url = this.autocompleteUrl + "?term=" + term;
        this.$http.get(url, null)
            .then((response) => {
                this.resultsProducts = response.data.products == null ? [] : response.data.products;
                this.resultsSuggestions = response.data.suggestions == null ? [] : response.data.suggestions;
                this.$rootScope.$broadcast('newSuggestSearchData');
            }, (error) => {
                this.$log.error('autocomplete: ' + error.status + ' ' + error.statusText);
            });
    }

    requestSuggestions(searchTerm) {
        // does nothing, if timeout already done
        this.$timeout.cancel(this.delayTimer);
        this.searchTermLength = searchTerm.length;

        if (this.searchTermLength < this.minCharactersBeforeRequest) {
            this.resultsProducts = [];
            this.resultsSuggestions = [];
        } else {
            this.delayTimer = this.$timeout(() => { // set timeout
                this.fetchSuggestions(searchTerm);
            }, this.waitTimeBeforeRequest);
        }
    }
}

export default SearchService;
